import { useSelector as useSelectorRedux, shallowEqual, TypedUseSelectorHook } from 'react-redux';
import { RootState } from '../rootReducer';

export const useSelector: TypedUseSelectorHook<RootState> = useSelectorRedux;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useShallowEqualSelector<TSelected>(selector: (s: RootState) => TSelected) {
  return useSelector(selector, shallowEqual);
}
